import isEmpty from 'lodash/isEmpty'
import loadRemoteScript from 'lib/load-remote-script'
import Conversion from './conversion'
// import devEnv from 'lib/env'

window.dataLayer = window.dataLayer || []
window.gtag = window.gtag || function () {
  window.dataLayer.push(arguments)
}

export default class GTag extends Conversion {
  constructor ({ ...rest } = {}) {
    super({ ...rest })
    this.tagId = 'G-T174PVKRD9'
    this.pushWithoutInstall = true
    this.pushWithoutConsent = true
    this.setupMaybe()
  }

  setup () {
    this.push('js', new Date())
    this.push('config', this.tagId)
    this.push('consent', 'default', {
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
      analytics_storage: 'denied'
    })
  }

  async install () {
    await loadRemoteScript({ url: `https://www.googletagmanager.com/gtag/js?id=${this.tagId}`, id: 'gtag-script' })
  }

  handleConsentGiven () {
    this.pushConsent()
  }

  pushConsent () {
    this.push('event', 'cookies_accepted', { event_category: 'engagement' })
    this.push('consent', 'update', {
      ad_storage: 'granted',
      ad_user_data: 'granted',
      ad_personalization: 'granted',
      analytics_storage: 'granted'
    })
  }

  deliver (item) {
    window.gtag(...item)
  }

  static formatItems (...items) {
    return items.map(item => this.formatItem(item))
  }

  // this should destruct the event object and return an array for gtag
  static formatItem (item) {
    if (!(item instanceof Array)) {
      return this.eventObjectToArray(item)
    }

    return item
  }

  static eventObjectToArray ({ type, event, ...rest }) {
    const args = [type, event].filter(item => !!item)
    !isEmpty(rest) && args.push(rest)
    return args
  }

  static ignoredEvents = ['view_home_page']

  static _log_name = 'ANLT GTag'
}
